
const TermsOfUse = () => {
  return (
    <div className="min-h-screen py-20">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="glass-card p-8 md:p-12 rounded-3xl">
            <h1 className="text-4xl md:text-5xl font-lora font-bold gradient-text mb-8">
              Pogoji uporabe
            </h1>
            
            <div className="prose prose-invert prose-lg max-w-none">
              <p className="text-white/80 text-lg leading-relaxed mb-8">
                Zadnja posodobitev: 1. januar 2024
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">1. Splošno</h2>
                <p className="text-white/80 leading-relaxed mb-4">
                  Ti pogoji uporabe urejajo uporabo spletne strani allmaverse.si in storitev, 
                  ki jih ponuja Alma Lovrenčič, s.p., z naslovom Žički prehod 4, 2000 Maribor 
                  (v nadaljevanju "Allmaverse").
                </p>
                <p className="text-white/80 leading-relaxed">
                  Z uporabo naše spletne strani se strinjate s temi pogoji uporabe. 
                  Če se s pogoji ne strinjate, prosimo, da ne uporabljate naših storitev.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">2. Storitve</h2>
                <p className="text-white/80 leading-relaxed mb-4">
                  Allmaverse ponuja naslednje storitve:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-white/80">
                  <li>Slikanje po naročilu</li>
                  <li>Slikarske delavnice za otroke in odrasle</li>
                  <li>Svetovanje za notranjo opremo</li>
                  <li>Prodaja umetniških izdelkov (keramika, tekstil, printi)</li>
                  <li>Organizacija umetniških dogodkov</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">3. Naročila in plačila</h2>
                <div className="text-white/80 leading-relaxed space-y-4">
                  <h3 className="text-xl font-medium text-white">3.1 Postopek naročanja</h3>
                  <p>
                    Naročila sprejemamo po telefonu, e-pošti ali osebno v ateljeju. 
                    Vsako naročilo mora biti potrjeno s strani Allmaverse.
                  </p>
                  
                  <h3 className="text-xl font-medium text-white">3.2 Cene in plačila</h3>
                  <p>
                    Cene so navedene v evrih in vključujejo DDV. Plačilo je možno z nakazilom, 
                    v gotovini ali s kartico (pri osebnem prevzemu).
                  </p>
                  
                  <h3 className="text-xl font-medium text-white">3.3 Akontacija</h3>
                  <p>
                    Za dela po naročilu zahtevamo 50% akontacijo pred začetkom dela. 
                    Preostali znesek je potrebno poravnati ob prevzemu.
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">4. Dobavni roki</h2>
                <p className="text-white/80 leading-relaxed">
                  Dobavni roki so orientirani in se lahko spremenijo glede na kompleksnost naročila 
                  in trenutno obremenitev. O morebitnih zamikih vas bomo obvestili v najkrajšem možnem času.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">5. Avtorske pravice</h2>
                <div className="text-white/80 leading-relaxed space-y-4">
                  <p>
                    Vsa umetniška dela so avtorsko zaščitena. Kupec pridobi pravico do lastništva 
                    fizičnega dela, ne pa avtorskih pravic.
                  </p>
                  <p>
                    Reprodukcija, kopiranje ali komercializacija del brez pisnega soglasja avtorja 
                    je prepovedana.
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">6. Reklamacije</h2>
                <div className="text-white/80 leading-relaxed space-y-4">
                  <p>
                    Reklamacije sprejemamo v 8 dneh od prevzema. Reklamacija mora biti vložena 
                    pisno z opisom napake in fotografijami.
                  </p>
                  <p>
                    Ne odgovarjamo za poškodbe, ki nastanejo zaradi nepravilnega ravnanja, 
                    transporta ali shranjevanja.
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">7. Odpoved in vračilo</h2>
                <div className="text-white/80 leading-relaxed space-y-4">
                  <h3 className="text-xl font-medium text-white">7.1 Dela po naročilu</h3>
                  <p>
                    Dela po naročilu so unikatna in se ne vračajo. Odpoved je možna le pred 
                    začetkom dela z odtegljajem akontacije.
                  </p>
                  
                  <h3 className="text-xl font-medium text-white">7.2 Delavnice</h3>
                  <p>
                    Odpoved delavnice je možna do 48 ur pred začetkom z vračilom polne cene. 
                    Pri poznejši odpovedi se cena ne vrača.
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">8. Omejitev odgovornosti</h2>
                <p className="text-white/80 leading-relaxed">
                  Allmaverse ne odgovarja za posredne ali posledične škode. Odgovornost je 
                  omejena na vrednost naročenega dela ali storitve.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">9. Reševanje sporov</h2>
                <p className="text-white/80 leading-relaxed">
                  Za reševanje sporov je pristojno sodišče v Mariboru. Uporablja se slovensko pravo.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">10. Kontakt</h2>
                <p className="text-white/80 leading-relaxed mb-4">
                  Za vprašanja v zvezi s pogoji uporabe nas kontaktirajte:
                </p>
                <div className="glass-card p-4 rounded-xl">
                  <p className="text-white/90">
                    <strong>E-pošta:</strong> alma.lovrencic@gmail.com<br />
                    <strong>Telefon:</strong> +386 51 479 667<br />
                    <strong>Naslov:</strong> Žički prehod 4, 2000 Maribor
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;